function Count(targetDom,rootPath){

	this.$target = $(targetDom);
	this.itemLength = this.$target.length;
	this.postTmer;

	this.counter = 0;
	this.targetId;
	this.beforeId = 'default';

	this.postPath = rootPath + '/arienai_ajax.php';

	//初期化
	this.init();

}

Count.prototype = {
	init : function(){
		this.bindEvent();
	},
	bindEvent : function() {
		var self = this;

		$(document).on('click.count','.arienai.count',function(e){
			e.preventDefault();
			self.action($(this));
		});
	},
	action : function(target){
		var self = this;

		var countAll = '.count-all';
		var numberCount = Number(target.children(countAll).text()) + 1;

		this.targetId = target.attr('id');
		if(this.beforeId === 'default'){
			this.beforeId = this.targetId;
		}


		if(9999 <= numberCount){
			target.children(countAll).text(9999);
			target.children(countAll).addClass('count-max');
		}else{
			target.children(countAll).text(numberCount);
		}

		clearTimeout(this.postTmer);
		
		if(this.targetId === this.beforeId){
//			console.log(this.targetId);
	
			this.counter = this.counter + 1;
	
			this.postTmer = setTimeout(function(){
				self.POST(self.counter,self.targetId);
			},500);
		}else{
			this.POST(this.counter,this.beforeId);
//			console.log(this.targetId);
			this.POST(1,this.targetId);
		}


	},
	POST : function(n,id){
//		console.log('POST arienai_count:' + n + ' post_id:' + id);
       	this.beforeId = id;
       	this.counter = 0;
		$.ajax({
            type: 'POST',
            url: this.postPath,
            data:{arienai_count:n,post_id:id}, 
            success: function(data){
//            	console.log(data);
            }
        });
	}
};

module.exports = Count;


/*****************
 ** WEBPACK FOOTER
 ** ./app/source/pc/js/module/count.js
 ** module id = 6
 ** module chunks = 5
 **/